module.exports = __webpack_public_path__ + "media/images/realizacje/real5-db2d08c594774a365604e7c0ca16fe86.png";